import React from 'react';
import { Grid, GridItem, VStack } from '@chakra-ui/react';
import SummaryCards from '../components/SummaryCards';
import SalesCompositionCard from '../components/SalesCompositionCard';
import SalesMonthlyCard from '../components/SalesMonthlyCard';
import TopSpenderCard from '../components/TopSpenderCard';
import MostPurchasedItemsCard from '../components/MostPurchasedItemsCard';

const RetailSection = (props) => {
  const {
    memberSummaryLoading,
    memberSummary,
    memberLabels,
    chartLoading,
    chartData,
    COLORS,
    surfaceCard,
    DASHBOARD_TYPE,
    DASHBOARD_SURFACE,
    formatNumber,
    formatCurrency,
    formatPercentage,
    topSpendersLoading,
    topSpenders,
    mostPurchasedItemsLoading,
    mostPurchasedItems,
    handleShowCustomerDetail,
    handleShowProductDetail,
  } = props;

  return (
    <VStack spacing={6} align="stretch">
      <Grid templateColumns="1fr" gap={5}>
        <GridItem>
          <SummaryCards
            memberSummaryLoading={memberSummaryLoading}
            memberSummary={memberSummary}
            selectedMember="RETAIL"
            memberLabels={memberLabels}
            DASHBOARD_TYPE={DASHBOARD_TYPE}
            DASHBOARD_SURFACE={DASHBOARD_SURFACE}
            surfaceCard={surfaceCard}
            formatNumber={formatNumber}
            formatCurrency={formatCurrency}
            formatPercentage={formatPercentage}
          />
        </GridItem>
      </Grid>

      <Grid
        templateColumns={{
          base: '1fr',
          lg: 'minmax(0, 1.18fr) minmax(360px, 0.82fr)',
          xl: 'minmax(0, 1.28fr) minmax(380px, 0.72fr)',
        }}
        gap={6}
        alignItems="stretch"
      >
        <GridItem h="full">
          <SalesCompositionCard
            mode="retail"
            title={memberLabels.compositionTitle}
            chartLoading={chartLoading}
            chartData={chartData}
            COLORS={COLORS}
            surfaceCard={surfaceCard}
            DASHBOARD_TYPE={DASHBOARD_TYPE}
            formatCurrency={formatCurrency}
            formatNumber={formatNumber}
          />
        </GridItem>
        <GridItem h="full">
          <SalesMonthlyCard
            mode="retail"
            title={memberLabels.monthlySalesTitle}
            chartLoading={chartLoading}
            chartData={chartData}
            COLORS={COLORS}
            surfaceCard={surfaceCard}
            DASHBOARD_TYPE={DASHBOARD_TYPE}
            formatCurrency={formatCurrency}
          />
        </GridItem>
      </Grid>

      <Grid templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }} gap={6}>
        <GridItem>
          <TopSpenderCard
            topSpendersLoading={topSpendersLoading}
            topSpenders={topSpenders}
            surfaceCard={surfaceCard}
            DASHBOARD_TYPE={DASHBOARD_TYPE}
            formatCurrency={formatCurrency}
            handleShowCustomerDetail={handleShowCustomerDetail}
          />
        </GridItem>
        <GridItem>
          <MostPurchasedItemsCard
            mostPurchasedItemsLoading={mostPurchasedItemsLoading}
            mostPurchasedItems={mostPurchasedItems}
            surfaceCard={surfaceCard}
            DASHBOARD_TYPE={DASHBOARD_TYPE}
            formatCurrency={formatCurrency}
            formatNumber={formatNumber}
            handleShowProductDetail={handleShowProductDetail}
          />
        </GridItem>
      </Grid>
    </VStack>
  );
};

export default RetailSection;
